import React, { Component } from 'react';
import add_box from '../images/add_box.svg';
import close_black from '../images/close-black.svg';
import deleteImg from '../images/delete.svg';
import Footer from './Footer';
import SideBar from './SideBar';
import Header from './Header';
import '../styles/Language.scss';
import Modal from 'react-modal';
import { Fragment } from 'react';
import loader from '../images/loader.gif';
import '../styles/CommonStyle.scss';
import spinner from '../images/spinner.png';
import { withTranslation } from 'react-i18next';
import SuccessAlert from './SuccessAlert';
import ErrorAlert from './ErrorAlert';
import checkcircle from '../images/check_circle_blue.svg';
import { getAllLanguage } from '../services/language-service';
import { addTenantLanguage, insertIntoHistoryTbl, updateTenant, deleteTenantLanguage, getTenantLanguages } from '../services/tenant-identity-service';
import { getTokenDetailsByDecoding } from '../services/cookie-storage-service';
import { Message } from '../enum/message';
import { FieldName } from "../enum/fieldName";
import { MessageType } from "../enum/message-type";

Modal.setAppElement("#root");

class Language extends Component {

    constructor(props) {
        super(props);
        this.state = {
            languageList: [],
            tenantLangArr: [],
            selectedItem: "",
            validationError: "",
            isModalOpen: false,
            isConfirmModalOpen: false,
            isLoading: false,
            alert_type: '',
            alert_message: '',
            selectedLanguageObj: {},
            systemLanguageList: []
        };
    }

    componentDidMount = async () => {
        await this.bindDropDowns();
        await this.getTenantLanguage();
    }

    languageOnChange = (e) => {
        this.setState({ selectedItem: e.target.value, validationError: e.target.value === "" ? "Please select language" : "" })
    }

    bindDropDowns = async () => {
        try {
            let languageArr = await getAllLanguage();
            this.setState({ isLoading: true });
            var langFromApi = languageArr.reduce(function (filtered, value) {
                if (value.Code !== 'en') {
                    var newObj = { value: value.LanguageId, display: value.Name }
                    filtered.push(newObj);
                }
                return filtered;
            }, []);

            this.setState({ systemLanguageList: langFromApi, languageList: langFromApi, isLoading: false });
        } catch (err) {
            this.setState({ isLoading: false });
            let finalMessage = err.response.data.message;
            this.setState({ alert_type: MessageType.ERROR })
            this.setState({ alert_message: finalMessage })
        }
    }

    clearAlertType = () => {
        setTimeout(() => {
            this.setState({ alert_type: '' });
        }, 4000);
    }

    addLanguage = async (e) => {
        e.preventDefault();
        this.clearAlertType();
        let languageArr = [];
        let tenantResult = this.props.auth.tenantResult;
        let languageList = this.state.systemLanguageList;
        let newLangArr = [];

        try {
            if (this.state.selectedItem === "") {
                this.setState({ alert_type: MessageType.ERROR });
                this.setState({ alert_message: Message.PLEASE_SELECT_LANGUAGE });
            } else {
                this.setState({ isLoading: true });
                languageArr.push(this.state.selectedItem);

                let inputData = {
                    "tenantGuid": tenantResult.tenantGuid,
                    "languageGuid": languageArr
                }

                let languageResult = await addTenantLanguage(inputData);
                tenantResult.languageCount = tenantResult.languageCount + 1;

                //Insert into history table.
                let historyData = {
                    "tenantGuid": tenantResult.tenantGuid,
                    "userGuid": this.props.auth.tenantUserGuid,
                    "masterId": 1,
                    "count": 1,
                    "licenseTypeGuid": ''
                }

                await insertIntoHistoryTbl(historyData);

                //Update Language Count in Tenant table.
                let tenantUpdateData = {
                    "tenantGuid": tenantResult.tenantGuid,
                    "companyName": tenantResult.companyName,
                    "userPoolName": tenantResult.userPoolName,
                    "identityPoolId": tenantResult.identityPoolId,
                    "clientId": tenantResult.clientId,
                    "region": tenantResult.region,
                    "isPurchase": tenantResult.isPurchase,
                    "locationCount": tenantResult.locationCount,
                    "productCount": tenantResult.productCount,
                    "webLicenseCount": tenantResult.webLicenseCount,
                    "pdaLicenseCount": tenantResult.pdaLicenseCount,
                    "userPoolId": tenantResult.userPoolId,
                    "languageCount": tenantResult.languageCount
                }

                await updateTenant(tenantUpdateData);

                let alertMessage = languageResult.data.message;
                this.setState({ alert_type: MessageType.SUCCESS })
                this.setState({ alert_message: alertMessage })

                languageList.forEach((lang) => languageResult.data.dataObject.languageGuid.forEach((obj) => {
                    if (lang['value'].toLowerCase() === obj.toLowerCase()) {
                        return newLangArr.push({ value: lang.value, display: lang.display, tenantGuid: tenantResult.tenantGuid });
                    }
                }));

                this.setState({ tenantLangArr: newLangArr });
                this.setState({ isLoading: false });
            }

        } catch (err) {
            this.setState({ isLoading: false });
            let finalMessage = err.response.data.message;
            this.setState({ alert_type: MessageType.ERROR })
            this.setState({ alert_message: finalMessage })
        }
        this.setState({ isModalOpen: false });
    }

    getTenantLanguage = async () => {
        let selectedLanguages = [];
        let languageList = this.state.systemLanguageList;
        let tenantGuid = getTokenDetailsByDecoding().tenantGuid;
        let response = await getTenantLanguages(tenantGuid);

        if (response.length > 0) {
            let selectedLangArr = response[0].languageGuid;
            let tenantGuid = response[0].tenantGuid;

            languageList.forEach((lang) => selectedLangArr.forEach((obj) => {
                if (lang['value'].toLowerCase() === obj.toLowerCase()) {
                    selectedLanguages.push({ value: lang.value, display: lang.display, tenantGuid: tenantGuid });
                }
            }));

            this.setState({ tenantLangArr: selectedLanguages });
        }
    }

    deleteLanguage = async (e) => {
        try {
            e.preventDefault();
            let item = this.state.selectedLanguageObj;
            let newLangArr = [];
            let tenantResult = this.props.auth.tenantResult;
            let languageList = this.state.systemLanguageList;
            this.setState({ isLoading: true });
            let response = await deleteTenantLanguage(item.value, item.tenantGuid);
            tenantResult.languageCount = tenantResult.languageCount - 1;

            //Insert into history table.
            let historyData = {
                "tenantGuid": tenantResult.tenantGuid,
                "userGuid": this.props.auth.tenantUserGuid,
                "masterId": 1,
                "count": -1,
                "licenseTypeGuid": ''
            }

            await insertIntoHistoryTbl(historyData);

            //Update Language Count in Tenant table.
            let tenantUpdateData = {
                "tenantGuid": tenantResult.tenantGuid,
                "companyName": tenantResult.companyName,
                "userPoolName": tenantResult.userPoolName,
                "identityPoolId": tenantResult.identityPoolId,
                "clientId": tenantResult.clientId,
                "region": tenantResult.region,
                "isPurchase": tenantResult.isPurchase,
                "locationCount": tenantResult.locationCount,
                "productCount": tenantResult.productCount,
                "webLicenseCount": tenantResult.webLicenseCount,
                "pdaLicenseCount": tenantResult.pdaLicenseCount,
                "userPoolId": tenantResult.userPoolId,
                "languageCount": tenantResult.languageCount
            }

            await updateTenant(tenantUpdateData);

            languageList.forEach((lang) => response.languageGuid.forEach((obj) => {
                if (lang['value'].toLowerCase() === obj.toLowerCase()) {
                    newLangArr.push({ value: lang.value, display: lang.display, tenantGuid: tenantResult.tenantGuid });
                }
            }));

            this.setState({ tenantLangArr: newLangArr });
            this.setState({ isLoading: false });

        } catch (err) {
            console.log('error', err.response);
            this.setState({ isLoading: false });
            let finalMessage = err.response.data.message;
            this.setState({ alert_type: MessageType.ERROR })
            this.setState({ alert_message: finalMessage })
        }
        this.setState({ isConfirmModalOpen: false });
    }

    handleModalClose = (event) => {
        this.setState({ isModalOpen: false })
    }

    handleModalOpen = (event) => {
        this.setState({ isModalOpen: true });
        let tenantLanguageList = this.state.tenantLangArr;
        let systemLanguageList = this.state.systemLanguageList;
        let tenantLanguageGuidList = tenantLanguageList.map((obj) => {
            return obj.value.toLowerCase();
        });


        let languageDropDownValue = systemLanguageList.filter((obj) => {
            return !tenantLanguageGuidList.includes(obj.value.toLowerCase())
        });

        if (languageDropDownValue.length > 0) {
            let defaultSelectedLanguage = languageDropDownValue.length > 0 ? languageDropDownValue[0].value : [];
            this.setState({ languageList: languageDropDownValue, selectedItem: defaultSelectedLanguage });
        } else {

        }
    }

    handleConfirmModalClose = event => {
        this.setState({ isConfirmModalOpen: false });
    }

    handleConfirmModalOpen = async (event, item) => {
        await this.setState({ isConfirmModalOpen: true });
        await this.setState({ selectedLanguageObj: item });
    }

    updateStateValue = () => {
        this.props.updateItem(this.state)
    }

    render() {
        const { t } = this.props;
        return (
            <main className="Dash-board">
                <div className="Dash-board-div">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <SideBar {...this.props} />
                            </div>
                            <div className="col-md-9">
                                <Header {...this.props} />
                                <div className="content-sec">

                                    {
                                        this.state.alert_type === MessageType.SUCCESS ? (<SuccessAlert message={this.state.alert_message} />) : null
                                    }

                                    {
                                        this.state.alert_type === MessageType.ERROR ? (<ErrorAlert message={this.state.alert_message} />) : null
                                    }

                                    {
                                        (this.state.tenantLangArr.length > 0 || this.state.languageList.length > 0) ? (
                                            <Fragment>
                                                <div className="primary-language">
                                                    <div className="language-text">{t('PRIMARY LANGUAGE')}</div>

                                                    <div className="add-new-language" onClick={this.handleModalOpen}><img src={add_box} alt="" /><span>{t('Add New Language')}</span></div>

                                                </div>
                                                <div className="language-contents">{t('Your primary language, which will be the default language for your system. You may add on additional languages, depending on the countries you work with most.')}</div>

                                                <div className="language-boxed">
                                                    <span>
                                                        <h4 className="language">{t('English')}</h4>
                                                    </span>
                                                    <h6>{t('Primary Language')}</h6>
                                                </div>



                                                <div className="language-text">{t('ADD-ON LANGUAGES')}</div>

                                                {/* {this.state.tenantLangArr.length === 0 && (
                                                    <div className="language-not-added">{t('You didnt have any')} <b>{t('Add-on Languages')}</b> {t('yet.')}</div>
                                                )} */}



                                                <div className="add-on-languages">
                                                    {this.state.tenantLangArr.map((elmt, i) => {
                                                        return (<div className="language-boxed" key={i}>
                                                            <span>
                                                                <h4 className="language">{elmt.display}</h4>
                                                                <div className="delete" onClick={(e) => { this.handleConfirmModalOpen(e, elmt) }} href=""><img src={deleteImg} alt="" style={{ cursor: "pointer" }} /></div>
                                                            </span>
                                                        </div>)
                                                    })}
                                                </div>

                                                <div className="free_translation">
                                                    <p>{t('Free Translations')} <span>{t('First 1000 words with each languages')}</span></p>
                                                    <div className="display_flex flex_align_center">
                                                        <img src={checkcircle} alt="" className="image-check-circless" />
                                                        <p className="margin_bottom_0">{t('6000 Words in total.')}</p>
                                                    </div>


                                                </div>



                                                <div className="bottom-button">

                                                    <button type="button" className="btn btn-secondary" onClick={() => { this.props.history.push('Summary') }}>{t('BACK')}</button>
                                                    <button type="button" className="btn btn-primary" onClick={() => { this.props.history.push('/Location') }}>{t('NEXT')}</button>
                                                </div>
                                            </Fragment>
                                        ) : (<img src={loader} alt="" className="loader" />)
                                    }

                                    {
                                        (this.state.isLoading) ? (
                                            <img src={loader} alt="" className="loader" />
                                        ) : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>


                {/* <!-- Modal --> */}

                <Modal
                    isOpen={this.state.isModalOpen}
                    onRequestClose={this.handleModalClose}
                    contentLabel="My dialog"
                    // className="mymodal"
                    // overlayClassName="myoverlay"
                    style={{
                        overlay: {
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            // backgroundColor: 'rgba(0, 0, 0, 0.75)'
                        },
                        content: {
                            position: 'absolute',
                            top: '0px',
                            left: '40px',
                            right: '40px',
                            bottom: '40px',
                            border: 'none',
                            background: 'none',
                            overflow: 'hidden',
                            WebkitOverflowScrolling: 'touch',
                            borderRadius: '4px',
                            outline: 'none',
                            padding: '0px'
                        }
                    }}
                // closeTimeoutMS={500}
                >
                    <div className="modal-dialog add-new-language-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{t('Add Language')}</h5>
                                <button type="button" className="close" onClick={this.handleModalClose}>
                                    <span><img src={close_black} alt="" /></span>
                                </button>
                            </div>

                            <fieldset disabled={this.state.isLoading}>
                                <form autoComplete="off" onSubmit={this.handleSubmit}>
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <label className="icon" htmlFor="language">{t('Select Language')}</label>
                                                <select className="form-control select" value={this.state.selectedItem} onChange={this.languageOnChange}>
                                                    {this.state.languageList && this.state.languageList.map((elmt) => <option key={elmt.value} value={elmt.value}>{elmt.display}</option>)}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" onClick={this.handleModalClose} className="btn btn-secondary" data-dismiss="modal">{t('CANCEL')}</button>
                                        <button type="submit" className="btn btn-primary" disabled={this.state.isLoading} onClick={this.addLanguage} >
                                            {this.state.isLoading && (
                                                <img src={spinner} alt="" className="btn-loader" />
                                            )}
                                            {t('Save')}
                                        </button>
                                    </div>
                                </form>
                            </fieldset>
                        </div>
                    </div>
                </Modal>

                <Modal
                    isOpen={this.state.isConfirmModalOpen}
                    onRequestClose={this.handleConfirmModalClose}
                    contentLabel="My Confirm dialog"
                    style={{
                        overlay: {
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0
                        },
                        content: {
                            position: 'unset',
                            top: '0px',
                            left: '40px',
                            right: '40px',
                            bottom: '40px',
                            border: 'none',
                            background: 'none',
                            overflow: 'hidden',
                            WebkitOverflowScrolling: 'touch',
                            borderRadius: '4px',
                            outline: 'none',
                            padding: '0px'
                        }
                    }}>
                    <div className="modal-dialog delete-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{t('Are you sure you want to delete?')}</h5>
                                <button type="button" className="close" onClick={this.handleConfirmModalClose}>
                                    <span><img src={close_black} alt="" /></span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <h5 className="modal-title">{t("This item will be deleted immediately. You can't undo this action.")}</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" onClick={this.handleConfirmModalClose} className="btn btn-secondary" data-dismiss="modal">{t('CANCEL')}</button>
                                <button type="submit" disabled={this.state.isLoading} onClick={(e) => { this.deleteLanguage(e) }} className="btn btn-primary" >
                                    {this.state.isLoading && (
                                        <img src={spinner} alt="" className="btn-loader" />
                                    )}{t('CONFIRM')}</button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </main >
        )
    }
};
export default withTranslation()(Language)